import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { SecurityPolicies } from '../services/auth-variables';
import { AuthService } from '../services/auth.service';

@Injectable()
export class HasWebAccessGuard implements CanActivate {

    constructor(private authService: AuthService, public router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authService.passesPolicyOf(SecurityPolicies.HasWebAccess);
    }
}

